import React, {Component} from "react";
import Modal from "../../../components/Modal";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {FadeLoader} from "react-spinners";
import Alert from "../../../components/Alert";
import DatePicker from "react-datepicker";
import _ from "lodash";
import moment from "moment";
import getListaPermisos from "../../../utils/getListaPermisos";
import {fetchAsignacionDefinitiva, savePedidoColor} from "../../../actions";

const IND_ENVIO_CORREO = "1";
const IND_SIN_ENVIO_CORREO = "0";
const IND_COLOR_FAB = 'N';
const IND_INACTIVO = 'N';

const ValidarAsignacionModal = props => (
    <Modal
        title="Validar asignación"
        idModal="validar-asignacion"
        isOpen
        closeModal={props.closeModal}
        modalSize="modal-dialog"
    >
        <p class="h4 bold text-center">
            ¿Desea validar la asignación de los siguientes pedidos?
        </p>
        <br/>

        {props.fdv.codFamiliaVeh !== "1" ? (
            <div class="text-center ">
                <table className="table table-hover">
                    <thead className="table-head">
                    <tr>
                        <th class="text-center"/>
                        <th class="text-center">Aplicar Fecha de C.C a todos</th>
                        <th class="text-center">
                            <DatePicker
                                className="form-control fSearch-search date-picker"
                                dateFormat="DD/MM/YYYY"
                                locale="es"
                                onChange={e => props.changeDateAll(e)}
                                selected={props.fechasPedidosTodos}
                            />
                        </th>
                    </tr>
                    </thead>
                </table>
            </div>
        ) : null}

        <br/>
        <br/>

        <div class="text-center ">
            <table className="table table-hover" style={{marginBottom: "100px"}}>
                <thead className="table-head">
                <tr>
                    <th class="text-center">Pedido</th>
                    <th class="text-center">Fecha Asig. Definitiva</th>
                    {props.fdv.codFamiliaVeh !== "1" ? (
                        <th class="text-center">Fecha C. De compromiso</th>
                    ) : null}
                    <th colSpan="2" class="text-center">
                        Notificacion
                    </th>
                </tr>
                </thead>
                <tbody>
                {props.arrayAsignarBonos.map((element, index) => (
                    <tr>
                        <td>{element}</td>
                        <td width="200">
                            <DatePicker
                                className="form-control fSearch-search date-picker"
                                dateFormat="DD/MM/YYYY"
                                locale="es"
                                placeholderText="Fecha Comercial"
                                selected={props.fnSelectedCambioDeFechaDef(element)}
                                onChange={e => props.changeDateDef(e, element)}
                            />
                        </td>
                        {props.fdv.codFamiliaVeh !== "1" ? (
                            <td width="200">
                                <DatePicker
                                    className="form-control fSearch-search date-picker"
                                    dateFormat="DD/MM/YYYY"
                                    locale="es"
                                    placeholderText="Fecha Comercial"
                                    selected={props.fnSelectedCambioDeFecha(element)}
                                    onChange={e => props.changeDate(e, element)}
                                />
                            </td>
                        ) : null}

                        {props.fechasPedidos.find(entry => entry.numPedidoVeh === element)
                            .ind_correo_aduana === 1 ? (
                            <td>
                                <div className="checkbox checkbox-inline">
                                    <label>
                                        <input type="checkbox" checked readOnly/>
                                        <div className="checkbox-skin"/>
                                        Notificar Desaduanaje
                                    </label>
                                </div>
                            </td>
                        ) : (
                            <td/>
                        )}

                        {/*REQ-86366*/
                            props.fechasPedidos.find(entry => entry.numPedidoVeh === element)
                                .ind_correo_aduana === 2 ? (
                                <td>
                                    <div className="checkbox checkbox-inline">
                                        <label>
                                            <input type="checkbox" checked readOnly/>
                                            <div className="checkbox-skin"/>
                                            Notificar Endoso de Documento
                                        </label>
                                    </div>
                                </td>
                            ) : (
                                <td/>
                            )/*REQ-86366*/}

                        {props.fechasPedidos.find(entry => entry.numPedidoVeh === element)
                            .ind_correo_warrant > 0 ? (
                            <td>
                                <div className="checkbox checkbox-inline">
                                    <label>
                                        <input type="checkbox" checked readOnly/>
                                        <div className="checkbox-skin"/>
                                        Notificar Warrant
                                    </label>
                                </div>
                            </td>
                        ) : (
                            <td/>
                        )}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
        <div class="modal-actions">
            <button
                class="btn btn-default"
                data-dismiss="modal"
                onClick={() => props.closeModal()}
            >
                Cancelar
            </button>
            <button
                class="btn btn-primary pull-right"
                data-dismiss="modal"
                onClick={e => props.validarAsignacion(e)}
            >
                Validar
            </button>
        </div>
    </Modal>
);

class ValidarAsignacion extends Component {
    constructor(props) {
        super(props);

        this.state = {
            muestraLoad: "none",
            pedidosXfichaVenta: [],
            fdvSelected: [],
            fechasPedidos: [],
            cordenadaX: 0,
            cordenadaY: 0,
            fechasPedidosTodos: "",
            objPermiso: {},
            pedido: []

        };
    }

    componentDidMount() {
        this.loadPage();
    }

    loadPage = () => {
        let fdvSelected = _.filter(
            this.props.pedidosXfichaVenta,
            _.property(this.props.profroma)
        )[0][this.props.profroma];

        //this.fnListaPermisos(this.props.fdvID, fdvSelected, 'ind_asigna_defi');
        this.setState({
            fechasPedidos: fdvSelected.map(entry =>
                Object.assign({}, entry, {fad: moment().toDate()})
            )
        });
        /*REQ-86366*/
        /* Se añadió el código, se agregó la propiedad pedido dentro del constructor,
         * Se crearon las variable fdvSelected2 y fdvSelected3, se validó ind_correo_aduana
         * para cuando sea != 0.
         * Se crearon las variables numPedidoVeh, nurFichaVtaPedido, codClie, codCIA
         * codProv, codFilial, codPropietarioVeh
         */
        /*REQ-86366*/

        let fdvSelected2 = fdvSelected.filter(entry =>
            this.props.arrayAsignarBonos.indexOf(entry.numPedidoVeh) >= 0
        );

        this.state.pedido = fdvSelected2[0];

        let fdvSelected3 = fdvSelected
            .filter(entry => entry.ind_correo_aduana !== 0)
            .map(entry => {
                return entry.numPedidoVeh;
            });
        this.setState({fdvSelected: fdvSelected3});
        this.fnListaPermisos(this.props.fdvID);
    };

    fnListaPermisos = (idFichaVenta, listPedidos, permisoTag) => {
        if (
            listPedidos !== undefined &&
            listPedidos !== undefined &&
            idFichaVenta !== undefined
        ) {
            getListaPermisos(idFichaVenta)
                .then(results => {
                    let listaPermisosFicha = [];
                    let listaPermisosPedidos = [];
                    let listaPermisosProforma = [];
                    if (results.data.estadoTrama === "1") {
                        listaPermisosFicha = results.data.permisosFicha;
                        listaPermisosPedidos = results.data.permisosPedidos.filter(entry =>
                            listPedidos
                                .map(entry => {
                                    return entry.numPedidoVeh;
                                })
                                .indexOf(entry.num_pedido)
                        );
                        listaPermisosPedidos = results.data.permisosPedidos.filter(
                            entry =>
                                entry.permisoTag === permisoTag && entry.valuePermiso === "V"
                        );
                        listaPermisosProforma = results.data.permisosProforma;
                    }

                    if (listaPermisosPedidos.length !== listPedidos.length) {
                        this.props.openAlert({
                            estadoTrama: "0",
                            mensaje: "El Pedido no cumple con la condicion para esta accion."
                        });
                        this.props.closeModal();
                    }
                })
                .catch(error => {
                    this.setState({loadInitial: ""});
                });
        }
    };

    fnPosition = e => {
        let cordenadaX = e.clientX;
        let cordenadaY = e.clientY;
        window.scrollTo(cordenadaX, cordenadaY);
    };

    fnSelectedCambioDeFecha = numPedidoVeh => {
        let fechaPedido = this.state.fechasPedidos.find(
            entry => entry.numPedidoVeh === numPedidoVeh
        );
        return typeof fechaPedido.fecComproEntrega !== "undefined" &&
        fechaPedido.fecComproEntrega !== null
            ? moment(fechaPedido.fecComproEntrega)
            : "";
    };

    changeDate = (e, numPedidoVeh) => {
        this.setState({
            fechasPedidos: this.state.fechasPedidos.map(
                entry =>
                    entry.numPedidoVeh === numPedidoVeh
                        ? Object.assign({}, entry, {fecComproEntrega: e})
                        : entry
            )
        });
    };

    fnSelectedCambioDeFechaDef = numPedidoVeh => {
        let fechaPedido = this.state.fechasPedidos.find(
            entry => entry.numPedidoVeh === numPedidoVeh
        );
        return typeof fechaPedido.fad !== "undefined" && fechaPedido.fad !== null
            ? moment(fechaPedido.fad)
            : "";
    };

    changeDateDef = (e, numPedidoVeh) => {
        this.setState({
            fechasPedidos: this.state.fechasPedidos.map(
                entry =>
                    entry.numPedidoVeh === numPedidoVeh
                        ? Object.assign({}, entry, {fad: e})
                        : entry
            )
        });
    };

    changeDateAll = e => {
        this.setState({
            fechasPedidosTodos: e,
            fechasPedidos: this.state.fechasPedidos.map(entry =>
                Object.assign({}, entry, {fecComproEntrega: e})
            )
        });
    };


    validarAsignacion = e => {
        this.fnPosition(e);
        this.setState({muestraLoad: "block"});
        const promises = [];


        if (this.props.validarAsignacion.length > 0) {
            this.props.arrayAsignarBonos.forEach(element => {
                const pedido = this.props.validarAsignacion.filter(pedido => pedido.numPedidoVeh === element)[0];
                const fecha = this.state.fechasPedidos.find(entry => entry.numPedidoVeh === pedido.numPedidoVeh).fecComproEntrega;
                const fechaAsigDef = this.state.fechasPedidos.find(entry => entry.numPedidoVeh === pedido.numPedidoVeh).fad;
                const colores = this.props.ordersColorsList.filter(entry => entry.numPedidoVeh===pedido.numPedidoVeh && entry.status===0)

                promises.push(
                    this.props.fetchAsignacionDefinitiva(
                        this.props.fdvID,
                        pedido.numPedidoVeh,
                        pedido.nurFichaVtaPedido,
                        this.props.profroma,
                        pedido.codClie,
                        "",
                        pedido.codCIA,
                        pedido.codProv,
                        this.props.fdv.vendedor,
                        pedido.codFilial,
                        pedido.codPropietarioVeh,
                        (this.state.fdvSelected.indexOf(element)>=0)
                            ? IND_ENVIO_CORREO
                            : IND_SIN_ENVIO_CORREO,
                        fecha !== null ? moment(fecha).format("DD/MM/YYYY") : "",
                        fechaAsigDef !== null ? moment(fechaAsigDef).format("DD/MM/YYYY") : ""
                    ).then((result) => {
                        console.log('result',result);
                        this.props.openAlert(result.payload.data);
                        if(colores.length>0){

                            colores.forEach(pedido => {
                                let arrayObjetosDeColores = [];
                                pedido.orderColors.forEach((color, index) =>{
                                    arrayObjetosDeColores.push({
                                        nurFichaVtaPedido:pedido.nurFichaVtaPedido,
                                        numColorFabricaVeh:color.numColfabVeh,
                                        codColorFabricaVeh:color.codColorFabricaVeh,
                                        indColorFab:IND_COLOR_FAB,
                                        indInactivo:IND_INACTIVO,
                                        numPedidoVeh:pedido.numPedidoVeh,
                                        desColorFabricaVeh:color.desColorFabricaVeh
                                    });
                                })
                                promises.push(this.props.savePedidoColor(this.props.fdvID,arrayObjetosDeColores));

                            });

                        }
                    })
                );
            });
        } else {
            this.props.arrayAsignarBonos.forEach(element => {

                /*REQ-86366*/
                const numPedidoVeh = this.state.pedido.numPedidoVeh;
                const nurFichaVtaPedido = this.state.pedido.nurFichaVtaPedido;
                const codClie = this.state.pedido.codCliente;
                const codCIA = this.state.pedido.codCia;
                const codProv = this.state.pedido.codProv;
                const codFilial = this.state.pedido.codFilial;
                const codPropietarioVeh = this.state.pedido.codPropietarioVeh;
                /*REQ-86366*/

                const fecha = this.state.fechasPedidos.find(entry => entry.numPedidoVeh === numPedidoVeh).fecComproEntrega;
                const fechaAsigDef = this.state.fechasPedidos.find(entry => entry.numPedidoVeh === numPedidoVeh).fad;
                const colores = this.props.ordersColorsList.filter(entry => entry.numPedidoVeh === numPedidoVeh && entry.status === 0)

                promises.push(
                    this.props.fetchAsignacionDefinitiva(
                        this.props.fdvID,
                        numPedidoVeh,
                        nurFichaVtaPedido,
                        this.props.profroma,
                        codClie,
                        "",
                        codCIA,
                        codProv,
                        this.props.fdv.vendedor,
                        codFilial,
                        codPropietarioVeh,
                        (this.state.fdvSelected.indexOf(element) >= 0)
                            ? IND_ENVIO_CORREO
                            : IND_SIN_ENVIO_CORREO,
                        fecha !== null ? moment(fecha).format("DD/MM/YYYY") : "",
                        fechaAsigDef !== null ? moment(fechaAsigDef).format("DD/MM/YYYY") : ""
                    ).then((result) => {
                        console.log('result', result);
                        this.props.openAlert(result.payload.data);
                        if (colores.length > 0) {

                            colores.forEach(pedido => {
                                let arrayObjetosDeColores = [];
                                pedido.orderColors.forEach((color, index) => {
                                    arrayObjetosDeColores.push({
                                        nurFichaVtaPedido: pedido.nurFichaVtaPedido,
                                        numColorFabricaVeh: color.numColfabVeh,
                                        codColorFabricaVeh: color.codColorFabricaVeh,
                                        indColorFab: IND_COLOR_FAB,
                                        indInactivo: IND_INACTIVO,
                                        numPedidoVeh: pedido.numPedidoVeh,
                                        desColorFabricaVeh: color.desColorFabricaVeh
                                    });
                                });
                                promises.push(this.props.savePedidoColor(this.props.fdvID, arrayObjetosDeColores));

                            });

                        }
                    })
                );
            })
        }

        Promise.all(promises).then(result => {
            this.props.doneAsignacionDefinitiva(true);
            this.props.clearCheck();
            this.props.fnUnSelectedAll();
            this.setState({ muestraLoad: "none" });
            this.props.fnChangeIndInitialize();
            this.props.changeIndex(this.props.activeFilterPedido);
            this.props.traerColorUso();
            this.props.closeModal();

        });
    };

    selectFDV = fdv => {
        const {fdvSelected} = this.state;
        if (fdvSelected.indexOf(fdv) >= 0) {
            this.setState({fdvSelected: fdvSelected.filter(f => f !== fdv)});
        } else {
            this.setState({fdvSelected: [...fdvSelected, fdv]});
        }
    };

    render() {
        return (
            <div>
                {this.state.fechasPedidos.length > 0 ? (
                    <ValidarAsignacionModal
                        arrayAsignarBonos={this.props.arrayAsignarBonos}
                        validarAsignacion={this.validarAsignacion}
                        closeModal={this.props.closeModal}
                        selectFDV={this.selectFDV}
                        fdvSelected={this.state.fdvSelected}
                        fechasPedidos={this.state.fechasPedidos}
                        changeDate={this.changeDate}
                        fnSelectedCambioDeFecha={this.fnSelectedCambioDeFecha}
                        changeDateAll={this.changeDateAll}
                        fechasPedidosTodos={this.state.fechasPedidosTodos}
                        changeAplicarDateAll={this.changeAplicarDateAll}
                        fdv={this.props.fdv}
                        fnSelectedCambioDeFechaDef={this.fnSelectedCambioDeFechaDef}
                        changeDateDef={this.changeDateDef}
                        doneAsignacionDefinitiva={this.props.doneAsignacionDefinitiva}
                    />
                ) : null}

                <div
                    className="modal extraFilter"
                    role="dialog"
                    data-backdrop="static"
                    style={{display: this.state.muestraLoad}}
                >
                    <div className="modal-dialog modal-sm" role="document">
                        <FadeLoader color={"#F8gA14A"} loading/>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        asginacionDefinitivaRP: state.asginacionDefinitivaRP
    };
}

export default withRouter(
    connect(mapStateToProps, {
        fetchAsignacionDefinitiva, savePedidoColor
    })(ValidarAsignacion)
);



// WEBPACK FOOTER //
// ./src/pages/modals/ValidarAsignacion/index.js